export default "__VITE_ASSET__BKr7j2ek__"